import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kh-dropdown',
  styleUrls: ['./dropdown.component.less'],
  templateUrl: './dropdown.component.html',
  standalone: false
})
export class DropdownComponent<TItem> {
  private static nextId = 0;

  private readonly dropdownId = DropdownComponent.nextId++;

  public readonly buttonId = `dropdown-button-${this.dropdownId}`;
  public readonly menuId = `dropdown-menu-${this.dropdownId}`;

  @Input() public items!: TItem[];
  @Input() public getName!: (item: TItem) => string | undefined;
  @Input() public selectedItem: TItem | unknown;
  @Input() public theme: string | undefined;
  @Input() public size: string | undefined;
  @Output() public readonly selectedItemChange = new EventEmitter<TItem>();

  public getClass(): string {
    return [this.theme ? `btn-${this.theme}` : '', this.size ? `btn-${this.size}` : '']
      .filter(Boolean)
      .join(' ');
  }

  public onItemClick(item: TItem): void {
    this.selectedItem = item;
    this.selectedItemChange.emit(item);
  }

  public resolveName(item: TItem): string {
    return item ? this?.getName(item) ?? '' : '';
  }
}
